import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import { getObjectFromSessionStore } from "app/utils/sessionStore";
import { getThemedPrimarySecondaryFromSource } from "app/utils/brandingTheme";
import { getReadableTextColor } from "app/utils/utils";
import { useContext } from "react";

const useBgBasedTextColor = (colorType: "primaryColor" | "secondaryColor" = "primaryColor") => {
  const { isDarkMode } = useContext(ThemeContext);
  const lookUpResponse = getObjectFromSessionStore("lookUpResponse");

  // these colors should match with the value --surface-ground variable
  // in /public/themes/*/theme.css
  const bgColor = isDarkMode ? "#040d19" : "#f5f5f5";
  const { primaryColor, secondaryColor } = getThemedPrimarySecondaryFromSource(
    lookUpResponse?.branding,
    "#002446",
    "#0283E8",
  );
  const base = colorType === "primaryColor" ? primaryColor : secondaryColor;
  return getReadableTextColor(
    bgColor,
    base || (colorType === "primaryColor" ? "#002446" : "#0283E8"),
  );
};

export default useBgBasedTextColor;
